module.exports = __webpack_public_path__ + "img/product_catalogue.fed6777a.svg";